(function () {

  /* ── Inject styles once ── */
  if (!document.getElementById('bqb-styles')) {
    var style = document.createElement('style');
    style.id  = 'bqb-styles';
    style.textContent = `
      #bqb-overlay {
        display: none;
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.5);
        z-index: 99998;
        backdrop-filter: blur(3px);
        -webkit-backdrop-filter: blur(3px);
      }
      #bqb-modal {
        display: none;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0.95);
        opacity: 0;
        transition: transform 0.3s cubic-bezier(0.32,0.72,0,1), opacity 0.25s ease;
        z-index: 99999;
        background: #fff;
        border-radius: 16px;
        width: 90vw;
        max-width: 860px;
        max-height: 90vh;
        overflow: hidden;
        box-shadow: 0 20px 60px rgba(0,0,0,0.2);
      }
      #bqb-modal.is-open {
        transform: translate(-50%, -50%) scale(1);
        opacity: 1;
      }
      #bqb-layout {
        display: grid;
        grid-template-columns: 1fr 1fr;
        min-height: 400px;
        max-height: 90vh;
      }
      #bqb-img-col {
        background: #f5f5f5;
        border-radius: 16px 0 0 16px;
        overflow: hidden;
        display: flex;
        align-items: stretch;
      }
      #bqb-img-col img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
        background: #f5f5f5;
      }
      #bqb-img-placeholder {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f0f0f0;
        color: #bbb;
        font-size: 13px;
      }
      #bqb-info-col {
        padding: 32px 28px 32px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        position: relative;
      }
      #bqb-close {
        position: absolute;
        top: 14px;
        right: 16px;
        width: 32px;
        height: 32px;
        border: none;
        background: #f0f0f0;
        border-radius: 50%;
        cursor: pointer;
        font-size: 18px;
        color: #555;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        transition: background 0.2s;
      }
      #bqb-close:hover { background: #e0e0e0; }
      .bqb-option-btn {
        padding: 8px 14px;
        border: 1.5px solid #ddd;
        background: #fff;
        color: #111;
        font-size: 13px;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.15s;
      }
      .bqb-option-btn:hover { border-color: #aaa; }
      .bqb-option-btn.selected {
        background: #111;
        color: #fff;
        border-color: #111;
      }
      .bqb-option-btn.unavailable {
        opacity: 0.35;
        text-decoration: line-through;
        cursor: not-allowed;
      }
      #bqb-atc {
        width: 100%;
        padding: 15px;
        background: #111;
        color: #fff;
        border: none;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.5px;
        cursor: pointer;
        transition: background 0.2s;
        margin-top: auto;
      }
      #bqb-atc:hover { background: #333; }
      #bqb-atc:disabled { opacity: 0.5; cursor: not-allowed; }
      #bqb-success {
        display: none;
        text-align: center;
        color: #2e7d32;
        font-size: 14px;
        font-weight: 600;
        margin-top: 12px;
      }
      #bqb-error {
        display: none;
        color: #c0392b;
        font-size: 13px;
        margin-bottom: 10px;
      }

      /* ── Mobile ── */
      @media (max-width: 600px) {
        #bqb-modal {
          width: 100vw;
          max-width: 100vw;
          max-height: 95vh;
          border-radius: 16px 16px 0 0;
          top: auto;
          bottom: 0;
          left: 0;
          right: 0;
          transform: translateY(100%);
          opacity: 1;
        }
        #bqb-modal.is-open {
          transform: translateY(0);
        }
        #bqb-layout {
          grid-template-columns: 1fr;
          overflow-y: auto;
          max-height: 95vh;
        }
        #bqb-img-col {
          border-radius: 16px 16px 0 0;
          height: auto;
          max-height: none;
        }
        #bqb-img-col img {
          width: 100%;
          height: auto;
          max-height: 70vw;
          object-fit: contain;
        }
        #bqb-info-col {
          padding: 20px 20px 32px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  /* ── Inject modal HTML once ── */
  if (!document.getElementById('bqb-modal')) {
    document.body.insertAdjacentHTML('beforeend', `
      <div id="bqb-overlay"></div>
      <div id="bqb-modal" role="dialog" aria-modal="true" aria-label="Aggiunta rapida al carrello">
        <div id="bqb-layout">
          <div id="bqb-img-col"></div>
          <div id="bqb-info-col">
            <button id="bqb-close" aria-label="Chiudi">&times;</button>
            <div id="bqb-inner">
              <div style="text-align:center;padding:60px 0;color:#bbb;font-size:14px;">Loading...</div>
            </div>
          </div>
        </div>
      </div>
    `);

    document.getElementById('bqb-overlay').addEventListener('click', closeBQB);
    document.getElementById('bqb-close').addEventListener('click', closeBQB);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeBQB();
    });
  }

  function openBQB() {
    var overlay = document.getElementById('bqb-overlay');
    var modal   = document.getElementById('bqb-modal');
    overlay.style.display = 'block';
    modal.style.display   = 'block';
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
    });
  }

  function closeBQB() {
    var modal   = document.getElementById('bqb-modal');
    var overlay = document.getElementById('bqb-overlay');
    modal.classList.remove('is-open');
    setTimeout(function () {
      modal.style.display   = 'none';
      overlay.style.display = 'none';
      document.getElementById('bqb-img-col').innerHTML  = '';
      document.getElementById('bqb-inner').innerHTML    = '<div style="text-align:center;padding:60px 0;color:#bbb;font-size:14px;">Loading...</div>';
      document.body.style.overflow = '';
    }, 320);
  }

  /* ── Load product and render ── */
  function loadProduct(handle) {
    openBQB();
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) { renderModal(product); })
      .catch(function () {
        document.getElementById('bqb-inner').innerHTML =
          '<p style="text-align:center;padding:40px 0;color:#999;">Could not load product.</p>';
      });
  }

  function renderModal(product) {
    /* ── Image col ── */
    var imgCol = document.getElementById('bqb-img-col');
    if (product.featured_image) {
      imgCol.innerHTML = '<img src="' + product.featured_image + '" alt="' + escHtml(product.title) + '">';
    } else {
      imgCol.innerHTML = '<div id="bqb-img-placeholder">No image</div>';
    }

    /* ── Info col ── */
    var inner = document.getElementById('bqb-inner');

    /* Price of first variant */
    var firstVariant = product.variants[0];
    var priceHTML = buildPriceHTML(firstVariant);

    /* Options — only if NOT the single default "Title" option */
    var hasRealOptions = !(product.options.length === 1 && product.options[0] === 'Title');
    var optionsHTML = '';

    if (hasRealOptions) {
      product.options.forEach(function (optRaw, optIdx) {
        /* product.options can be strings OR objects with a .name property
           depending on the Shopify theme/app — handle both */
        var optName = typeof optRaw === 'string'
          ? optRaw
          : (optRaw && (optRaw.name || optRaw.label || JSON.stringify(optRaw)));

        /* Collect unique values for this option
           v.options[] is always a plain string array in the .js endpoint */
        var seen   = {};
        var values = [];
        product.variants.forEach(function (v) {
          /* Try v.options[] first, fall back to v.option1/2/3 */
          var val = (v.options && v.options[optIdx] !== undefined)
            ? v.options[optIdx]
            : v['option' + (optIdx + 1)];
          /* Ensure it's a string */
          if (val !== undefined && val !== null) {
            val = String(val);
            if (!seen[val]) {
              seen[val] = true;
              values.push(val);
            }
          }
        });

        optionsHTML += '<div style="margin-bottom:16px;">';
        optionsHTML += '<p style="font-size:11px;font-weight:700;letter-spacing:1.2px;text-transform:uppercase;margin:0 0 8px;color:#555;">'
          + escHtml(String(optName)) + '</p>';
        optionsHTML += '<div style="display:flex;flex-wrap:wrap;gap:8px;">';

        values.forEach(function (val, i) {
          var isFirst = i === 0;
          optionsHTML += '<button type="button" class="bqb-option-btn' + (isFirst ? ' selected' : '') + '"'
            + ' data-opt-idx="' + optIdx + '"'
            + ' data-opt-val="' + escHtml(val) + '">'
            + escHtml(val)
            + '</button>';
        });

        optionsHTML += '</div></div>';
      });
    }

    inner.innerHTML = `
      <h3 style="font-size:17px;font-weight:600;margin:0 0 8px;padding-right:32px;line-height:1.3;">${escHtml(product.title)}</h3>
      <div id="bqb-price" style="font-size:15px;margin-bottom:22px;">${priceHTML}</div>
      <div id="bqb-options">${optionsHTML}</div>
      <div id="bqb-error">Please select all options before adding to cart.</div>
      <button id="bqb-atc" type="button">Add to Cart</button>
      <p id="bqb-success">✓ Added to cart!</p>
    `;

    /* ── Option pill clicks ── */
    inner.querySelectorAll('.bqb-option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('unavailable')) return;

        var idx = btn.getAttribute('data-opt-idx');
        inner.querySelectorAll('.bqb-option-btn[data-opt-idx="' + idx + '"]').forEach(function (b) {
          b.classList.remove('selected');
        });
        btn.classList.add('selected');

        updatePrice(inner, product);
      });
    });

    /* ── ATC ── */
    document.getElementById('bqb-atc').addEventListener('click', function () {
      var variantId = getSelectedVariant(inner, product);
      if (!variantId) {
        document.getElementById('bqb-error').style.display = 'block';
        return;
      }
      document.getElementById('bqb-error').style.display = 'none';

      var atcBtn = document.getElementById('bqb-atc');
      atcBtn.disabled     = true;
      atcBtn.textContent  = 'Aggiunta...';

      /* Use sections API so cart drawer gets updated HTML in one request */
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      /* Find section IDs the theme needs to update (same as ProductForm does) */
      var sectionsToUpdate = ['page-header', 'cart-drawer']
        .map(function(sel) { return document.querySelector(sel); })
        .filter(Boolean);
      var sectionIds = sectionsToUpdate.map(function(el) { return el.dataset.sectionId; });

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sectionIds.join(','));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        /* 1. Update each section (header count + cart drawer contents) */
        if (data.sections) {
          sectionsToUpdate.forEach(function (el) {
            if (data.sections[el.dataset.sectionId] && typeof el.updateFromCartChange === 'function') {
              el.updateFromCartChange(data.sections[el.dataset.sectionId]);
            }
          });
        } else {
          /* Fallback: fire on:cart:change so CartForm.refresh() picks it up */
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }

        /* 2. Close our modal */
        closeBQB();

        /* 3. Open the cart drawer — same way the theme does it */
        var cartDrawer = document.querySelector('.js-cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
            bubbles: true,
            detail: { opener: null }
          }));
        }
      })
      .catch(function () {
        atcBtn.disabled    = false;
        atcBtn.textContent = 'Aggiungi al carrello';
        var errEl = document.getElementById('bqb-error');
        errEl.textContent   = 'Si è verificato un errore. Riprova.';
        errEl.style.display = 'block';
      });
    });
  }

  /* ── Get matching variant from selected pills ── */
  function getSelectedVariant(inner, product) {
    var hasRealOptions = !(product.options.length === 1 && product.options[0] === 'Title');
    if (!hasRealOptions) return product.variants[0].id;

    var selected = [];
    for (var i = 0; i < product.options.length; i++) {
      var active = inner.querySelector('.bqb-option-btn[data-opt-idx="' + i + '"].selected');
      if (!active) return null;
      selected.push(active.getAttribute('data-opt-val'));
    }

    var match = null;
    product.variants.forEach(function (v) {
      var matches = selected.every(function (val, i) {
        var vVal = (v.options && v.options[i] !== undefined)
          ? String(v.options[i])
          : String(v['option' + (i + 1)]);
        return vVal === val;
      });
      if (matches) match = v.id;
    });
    return match;
  }

  /* ── Update price when option changes ── */
  function updatePrice(inner, product) {
    var variantId = getSelectedVariant(inner, product);
    if (!variantId) return;
    var variant = null;
    product.variants.forEach(function (v) { if (v.id === variantId) variant = v; });
    if (!variant) return;

    var priceEl = document.getElementById('bqb-price');
    if (priceEl) priceEl.innerHTML = buildPriceHTML(variant);
  }

  function buildPriceHTML(variant) {
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      return '<s style="color:#aaa;margin-right:6px;font-size:14px;">' + formatMoney(variant.compare_at_price) + '</s>'
        + '<span style="color:#c0392b;font-weight:700;">' + formatMoney(variant.price) + '</span>';
    }
    return '<span style="font-weight:700;">' + formatMoney(variant.price) + '</span>';
  }

  /* ── Intercept bundle "+ Ajouter" clicks ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.vv-product-bundle-container .product-card__quick-add-button');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var card  = btn.closest('.product-card-upsell');
    var links = card ? card.querySelectorAll('a[href*="/products/"]') : [];
    var handle = null;
    links.forEach(function (a) {
      var m = (a.getAttribute('href') || '').match(/\/products\/([^?#/]+)/);
      if (m) handle = m[1];
    });
    if (!handle) return;
    loadProduct(handle);
  });

  /* ── Helpers ── */
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, '{{amount}}');
    }
    var symbol = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '€';
    return symbol + (cents / 100).toFixed(2);
  }

  function escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

})();